import { render, staticRenderFns } from "./braceletDetail.vue?vue&type=template&id=cfbaff16&"
import script from "./braceletDetail.vue?vue&type=script&lang=js&"
export * from "./braceletDetail.vue?vue&type=script&lang=js&"
import style0 from "./braceletDetail.vue?vue&type=style&index=0&id=cfbaff16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports